import {Injectable} from '@angular/core';
import {RestService} from "../rest.service";
import {ErrorsService, SALVAR} from "../errors/errors.service";
import {URL_API} from "../../tools/URL";
import {catchError} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class FaleComRhService {

  constructor(
    private rest: RestService,
    private errorsService: ErrorsService) {
  }

  carregarPorId(id: number) {
    return this.rest.get(`${URL_API.PATH_FALE_COM_RH + '/' + id}`);
  }

  salvar(registro: { } , enviar: boolean = true) {
    if(enviar){
      return this.rest.post(`${URL_API.PATH_FALE_COM_RH}/enviar`, registro).pipe(
        catchError(response => this.errorsService.handleError(response, SALVAR))
      );
    }else{
      return this.rest.post(`${URL_API.PATH_FALE_COM_RH}/salvar`, registro).pipe(
        catchError(response => this.errorsService.handleError(response, SALVAR))
      );
    }
  }

  atualizar(id: number, registro: { } , enviar: boolean = true) {
    if(enviar){
      return this.rest.put(`${URL_API.PATH_FALE_COM_RH}/enviar/${id}`, registro).pipe(
        catchError(response => this.errorsService.handleError(response, SALVAR))
      );
    }else{
      return this.rest.put(`${URL_API.PATH_FALE_COM_RH}/salvar/${id}`, registro).pipe(
        catchError(response => this.errorsService.handleError(response, SALVAR))
      );
    }
  }
}
